import { openEnrollmentSelectLocationFactory } from '@/factories/open-enrollment/select-location.factory'
import EventsApi from '@/Api/EventsApi'

export async function getEventLocationsList(options) {
  if (process.env.VUE_APP_OE_MOCK_DATA === 'true') {
    return openEnrollmentSelectLocationFactory()
  } else {
    return await new EventsApi().getEventLocationsList(options)
      .then((response) => {
        return openEnrollmentSelectLocationFactory(response)
      })
      .catch(() => '404 - Not Found')
  }
}

export async function getEventRequestList(options) {
  if (process.env.VUE_APP_OE_MOCK_DATA === 'true') {
    return openEnrollmentSelectLocationFactory()
  } else {
    return await new EventsApi().getEventRequestList(options)
      .then((response) => {
        return openEnrollmentSelectLocationFactory(response)
      })
      .catch((err) => err)
  }
}

export async function createLocation(options) {
  if (process.env.VUE_APP_OE_MOCK_DATA === 'true') {
    return openEnrollmentSelectLocationFactory()
  } else {
    return await new EventsApi().createLocation(options)
      .then((res) => {
        return openEnrollmentSelectLocationFactory([res])[0]
      })
  }
}
